import { useState } from 'react';
import s from './DiagnosticsTab.module.scss';

const STATUS_ICON = { ok: '✓', warn: '!', fail: '✕' };

export default function DiagnosticsTab({ api }) {
    const [loading, setLoading] = useState(false);
    const [checks, setChecks] = useState(null);
    const [error, setError] = useState('');
    const [expanded, setExpanded] = useState({});

    const run = async () => {
        setLoading(true);
        setError('');
        setChecks(null);
        try {
            const r = await api.get('/diagnostics');
            const list = r.data?.checks || [];
            setChecks(list);
            // Проблемные пункты раскрываем сразу — инструкция на виду
            const exp = {};
            list.forEach(c => { if (c.status === 'fail' && c.instruction) exp[c.id] = true; });
            setExpanded(exp);
        } catch (e) {
            setError(e?.response?.data?.detail || 'Не удалось выполнить диагностику. Попробуйте ещё раз.');
        } finally {
            setLoading(false);
        }
    };

    const toggle = (id) => setExpanded(prev => ({ ...prev, [id]: !prev[id] }));

    const failCount = checks ? checks.filter(c => c.status === 'fail').length : 0;
    const warnCount = checks ? checks.filter(c => c.status === 'warn').length : 0;

    return (
        <div className={s.container}>
            <h2 className={s.title}>Самодиагностика</h2>
            <p className={s.hint}>
                Проверим основные настройки приложения: авторизацию на портале, соответствие полей,
                подключение hh.ru и подписку. Обычно занимает несколько секунд.
            </p>

            <div>
                <button className={s.runBtn} onClick={run} disabled={loading}>
                    {loading && <span className={s.spinner}/>}
                    {loading ? 'Проверяем…' : 'Провести самодиагностику'}
                </button>
            </div>

            {error && <div className={s.error}>{error}</div>}

            {checks && !loading && (
                <>
                    <div className={s.summary}>
                        {failCount === 0 && warnCount === 0 && 'Все проверки пройдены — настройки в порядке.'}
                        {failCount > 0 && `Найдено проблем: ${failCount}. Раскройте пункты с крестиком — там инструкция.`}
                        {failCount === 0 && warnCount > 0 && 'Критичных проблем нет, но есть что улучшить.'}
                    </div>
                    <div className={s.list}>
                        {checks.map(c => {
                            const openable = Boolean(c.instruction) && c.status !== 'ok';
                            const open = Boolean(expanded[c.id]);
                            return (
                                <div key={c.id} className={s.item}>
                                    <div
                                        className={`${s.row} ${openable ? s.rowClickable : ''}`}
                                        onClick={() => openable && toggle(c.id)}
                                    >
                                        <span className={`${s.icon} ${s['icon_' + c.status]}`}>
                                            {STATUS_ICON[c.status] || '?'}
                                        </span>
                                        <div className={s.texts}>
                                            <div className={s.itemTitle}>{c.title}</div>
                                            <div className={s.itemMsg}>{c.message}</div>
                                        </div>
                                        {openable && (
                                            <span className={`${s.chevron} ${open ? s.chevronOpen : ''}`}>›</span>
                                        )}
                                    </div>
                                    {openable && open && (
                                        <div className={s.instruction}>
                                            <b>Что сделать: </b>{c.instruction}
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </>
            )}
        </div>
    );
}
